import { eAccountType, eCampaignObjectiveTypeMeta, eCampaignStatus, eCreativeStatusBuild, ePerformanceGoalTypeMeta, ePerformanceGoalTypeMetaName, eStandardCampaginChannel } from '@Workspace/_generated/enums';
import { IBaseCampaignDto, IEnumDataAttribute, IMetaAudienceJson, IMetaSettingsJson } from '@Workspace/_generated/interfaces';
import { CampaignController } from '@Workspace/_generated/services';
import { LookUps } from '@Workspace/common';
import { PageLoaderService } from '@Workspace/services';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MessageService, SelectItem } from 'primeng/api';
import { Subject } from 'rxjs';

@Component({
    selector: 'meta-api-build-dialog',
    templateUrl: './meta-api-build-dialog.html',
    styleUrls: ['./meta-api-build-dialog.scss'],
})
export class MetaApiBuildDialog implements OnInit, OnDestroy {
    isVisible: boolean = false;
    buyingType: number;
    campaignObjective: eCampaignObjectiveTypeMeta;
    bidStrategy: number;
    metaDataPixelId: number;
    adAccountId: string;
    adAccountName: string;
    baseCampaign: IBaseCampaignDto;
    campaignId ;
    MetaRTAudienceIncludeOptions: SelectItem[];
    MetaRTAudienceExcludeOptions: SelectItem[];
    MetaLALAudienceIncludeOptions: SelectItem[];
    MetaLALAudienceExcludeOptions: SelectItem[];
    SelectedMetaRTAudienceIncludeOptions: SelectItem[];
    SelectedMetaRTAudienceExcludeOptions: SelectItem[];
    SelectedMetaLALAudienceIncludeOptions: SelectItem[];
    SelectedMetaLALAudienceExcludeOptions: SelectItem[];
    facebookPageId:number;
    metaPageId:number;
    enumAccountType = eAccountType;
    allMetaAudiences: SelectItem[];
    metaSettingsJson: IMetaSettingsJson;
    initialAdAccountId: string;
    performanceGoal: ePerformanceGoalTypeMeta;
    isAdAccountIdValid : boolean = true;

    buyingTypeOptions: SelectItem[] = [
        {value: 1, label: 'Auction'}
    ];
    campaignObjectiveOptions: SelectItem[] = [];
    bidStrategyOptions: SelectItem[] = [
        {value: 1, label: 'Highest volume or value'},
        {value: 2, label: 'Bid Cap'}
    ];
    performanceGoalOptions = [];
    goalMap : any;

    ngUnsubscribe = new Subject();

    constructor(public campaignController: CampaignController,
        public messageService : MessageService,
        private pageLoader: PageLoaderService) {
    }

    ngOnInit() {
        this.campaignObjectiveOptions = LookUps.getCampaignObjectiveList();
        this.prepareGoals();
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    openDialog(campaign: IBaseCampaignDto) {
        this.isVisible = true;
        this.baseCampaign = campaign;
        this.metaSettingsJson = this.baseCampaign.metaSettingsJson;
        this.buyingType = !!this.metaSettingsJson && !!this.metaSettingsJson.buyingType ? Number(this.metaSettingsJson.buyingType) : 1;
        this.metaDataPixelId = !!this.metaSettingsJson && !!this.metaSettingsJson.metaDatasetPixelId ? Number(this.metaSettingsJson.metaDatasetPixelId) : (!!this.baseCampaign.account.metaDatasetPixelId ? Number(this.baseCampaign.account.metaDatasetPixelId) : null);
        if(this.baseCampaign.campaignType == eAccountType.FAN365){
            this.adAccountId = !!this.metaSettingsJson && !!this.metaSettingsJson.adAccountId ? this.metaSettingsJson.adAccountId : "act_275811476918746";
            this.adAccountName = 'Fan365';
            this.campaignObjective = !!this.metaSettingsJson && !!this.metaSettingsJson.campaignObjective ? this.metaSettingsJson.campaignObjective : eCampaignObjectiveTypeMeta.Traffic;
            this.bidStrategy = !!this.metaSettingsJson && !!this.metaSettingsJson.bidStrategy ? Number(this.metaSettingsJson.bidStrategy) : 2;
        }
        else{
            this.adAccountId = !!this.metaSettingsJson && !!this.metaSettingsJson.adAccountId ? this.metaSettingsJson.adAccountId : (!!this.baseCampaign.account.metaAdAccountId ? this.baseCampaign.account.metaAdAccountId : null);
            this.initialAdAccountId = this.adAccountId;
            if(this.adAccountId != null || this.adAccountId != undefined){
                this.getAudience();
            }
            this.adAccountName = !!this.metaSettingsJson && !!this.metaSettingsJson.adAccountName ? this.metaSettingsJson.adAccountName : (!!this.baseCampaign.account.metaAdAccountName ? this.baseCampaign.account.metaAdAccountName : null);
            this.campaignObjective = !!this.metaSettingsJson && !!this.metaSettingsJson.campaignObjective ? this.metaSettingsJson.campaignObjective : null;
            this.bidStrategy = !!this.metaSettingsJson && !!this.metaSettingsJson.bidStrategy ? Number(this.metaSettingsJson.bidStrategy) : 1;
        }
        this.performanceGoal = !!this.metaSettingsJson && !!this.metaSettingsJson.performanceGoal ? this.metaSettingsJson.performanceGoal : null;
        this.campaignId = campaign.id;
        this.facebookPageId = this.baseCampaign.isFacebookPageIdEnteredInHub ? this.baseCampaign.facebookPageId : null;
        this.metaPageId = this.baseCampaign.account.metaPageId;
        this.performanceGoalOptions = this.goalMap[this.campaignObjective] || [];
    }
    cancel(){
        this.isVisible = false;
        this.metaDataPixelId = null;
        this.adAccountId = null;
        this.adAccountName = null;
        this.facebookPageId = null;
        this.metaPageId = null;
        this.SelectedMetaLALAudienceIncludeOptions = [];
        this.SelectedMetaLALAudienceExcludeOptions = [];
        this.SelectedMetaRTAudienceIncludeOptions = [];
        this.SelectedMetaRTAudienceExcludeOptions = [];
    }

    save(){
        this.pageLoader.showPageLoader();
        if(this.baseCampaign.metaSettingsJson == null){
            this.baseCampaign.metaSettingsJson = {} as IMetaSettingsJson;
        }
        this.baseCampaign.metaSettingsJson = this.populateMetaSettings();

        if(this.adAccountId != this.initialAdAccountId)
            this.baseCampaign.isMetaAdAccountIdEnteredInHub = true;

        if(this.facebookPageId != null){
            this.baseCampaign.isFacebookPageIdEnteredInHub = true;
            this.baseCampaign.facebookPageId = this.facebookPageId;
        }

        // Update campaign status and creative status build
        this.baseCampaign.statusId = eCampaignStatus.Sent_to_API_Build;
        this.baseCampaign.creatives
                .filter(cr =>
                    cr.creativeTypeId === eStandardCampaginChannel.Facebook_Static_News_Feed ||
                    cr.creativeTypeId === eStandardCampaginChannel.Facebook_Dynamic_News_Feed ||
                    cr.creativeTypeId === eStandardCampaginChannel.Facebook_Dynamic_News_Feed_Video ||
                    cr.creativeTypeId === eStandardCampaginChannel.Facebook_News_Feed_Carousel ||
                    cr.creativeTypeId === eStandardCampaginChannel.Facebook_Static_News_Feed_Video ||
                    cr.creativeTypeId === eStandardCampaginChannel.Paid_support ||
                    cr.creativeTypeId === eStandardCampaginChannel.Content ||
                    cr.creativeTypeId === eStandardCampaginChannel.Snap_AR ||
                    cr.creativeTypeId === eStandardCampaginChannel.Social_Lead_Generation ||
                    cr.creativeTypeId === eStandardCampaginChannel.Social_Lead_Generation_Premium ||
                    cr.creativeTypeId === eStandardCampaginChannel.Digital_Game
                )
                .forEach(cr => {
                    if ( cr.creativeAssets.some(ca => ca.file) && cr.creativeAssets.filter(ca => ca.file != null).every(ca => ca.isValid === true)) {
                        cr.creativeStatusBuildId = eCreativeStatusBuild.Send_to_API;
                    }
                });


        this.campaignController.SaveMetaSettings(this.baseCampaign).subscribe(
            data=>{
                this.isVisible = false;
                this.pageLoader.hidePageLoader();
                this.messageService.add({ severity: 'success', summary: 'Successfully Saved', detail: 'Meta settings are successfully saved.' });
                this.campaignController.BuildMetaCampaign(this.campaignId, true).subscribe();
            },
            error=>{
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error.error.text });
            }
        );
    }

    populateMetaSettings(){
        let metaSettings = this.baseCampaign.metaSettingsJson;
        metaSettings.adAccountId = this.adAccountId.toString();
        metaSettings.adAccountName = this.adAccountName;
        metaSettings.bidStrategy = this.bidStrategy.toString();
        metaSettings.buyingType = this.buyingType.toString();
        metaSettings.campaignObjective = this.campaignObjective;
        metaSettings.performanceGoal = this.performanceGoal;
        metaSettings.metaDatasetPixelId = this.metaDataPixelId != null ? this.metaDataPixelId : null;
        metaSettings.rtCustomeAudiencesInclude = !!this.SelectedMetaRTAudienceIncludeOptions ? this.SelectedMetaRTAudienceIncludeOptions.map(audience => ({
                                            id: audience.value,
                                            name: audience.label,
                                            type: 'Custom'
                                            })) as IMetaAudienceJson[] : null;
        metaSettings.rtCustomeAudiencesExclude = !!this.SelectedMetaRTAudienceExcludeOptions ? this.SelectedMetaRTAudienceExcludeOptions.map(audience => ({
                                            id: audience.value,
                                            name: audience.label,
                                            type: 'Custom'
                                            })) as IMetaAudienceJson[] : null;
        metaSettings.lalCustomeAudiencesInclude = !!this.SelectedMetaLALAudienceIncludeOptions ? this.SelectedMetaLALAudienceIncludeOptions.map(audience => ({
                                            id: audience.value,
                                            name: audience.label,
                                            type: 'Custom'
                                            })) as IMetaAudienceJson[] : null;
        metaSettings.lalCustomeAudiencesExclude = !!this.SelectedMetaLALAudienceExcludeOptions ? this.SelectedMetaLALAudienceExcludeOptions.map(audience => ({
                                            id: audience.value,
                                            name: audience.label,
                                            type: 'Custom'
                                            })) as IMetaAudienceJson[] : null;

        return metaSettings;
    }

    getAudience() {
        if(this.baseCampaign.campaignType != eAccountType.FAN365){
            this.pageLoader.showPageLoader();

            const formattedAdAccountId = this.adAccountId.startsWith('act_')? this.adAccountId: `act_${this.adAccountId}`;

            this.campaignController.GetMetaAudiences(formattedAdAccountId).subscribe(data => {
                    this.allMetaAudiences = data.map(audience => ({
                        value: audience.metaAudienceId,
                        label: audience.metaAudienceName,
                    }
                ));
                this.MetaRTAudienceIncludeOptions = [...this.allMetaAudiences];
                this.MetaRTAudienceExcludeOptions = [...this.allMetaAudiences];
                this.MetaLALAudienceIncludeOptions = [...this.allMetaAudiences];
                this.MetaLALAudienceExcludeOptions = [...this.allMetaAudiences];

                if (this.metaSettingsJson?.rtCustomeAudiencesInclude?.length) {
                    this.SelectedMetaRTAudienceIncludeOptions =
                        this.allMetaAudiences.filter(option =>
                            this.metaSettingsJson?.rtCustomeAudiencesInclude
                            ?.some(db => db.id === option.value)
                        );
                }
                
                if (this.metaSettingsJson?.rtCustomeAudiencesExclude?.length) {
                    this.SelectedMetaRTAudienceExcludeOptions =
                        this.allMetaAudiences.filter(option =>
                            this.metaSettingsJson?.rtCustomeAudiencesExclude
                            ?.some(db => db.id === option.value)
                        );
                }

                if (this.metaSettingsJson?.lalCustomeAudiencesInclude?.length) {
                    this.SelectedMetaLALAudienceIncludeOptions =
                        this.allMetaAudiences.filter(option =>
                            this.metaSettingsJson?.lalCustomeAudiencesInclude
                            ?.some(db => db.id === option.value)
                        );
                }

                if (this.metaSettingsJson?.lalCustomeAudiencesExclude?.length) {
                    this.SelectedMetaLALAudienceExcludeOptions =
                        this.allMetaAudiences.filter(option =>
                            this.metaSettingsJson?.lalCustomeAudiencesExclude
                            ?.some(db => db.id === option.value)
                        );
                }
                this.pageLoader.hidePageLoader();
            });
        }
    }

    updateRTAudienceOptions() {
        this.MetaRTAudienceIncludeOptions = this.getFilteredOptions(
            this.allMetaAudiences,
            this.SelectedMetaRTAudienceExcludeOptions
        );
        this.MetaRTAudienceExcludeOptions = this.getFilteredOptions(
            this.allMetaAudiences,
            this.SelectedMetaRTAudienceIncludeOptions
        );
    }

    updateLALAudienceOptions(){
        this.MetaLALAudienceIncludeOptions = this.getFilteredOptions(
            this.allMetaAudiences,
            this.SelectedMetaLALAudienceExcludeOptions
        );
        this.MetaLALAudienceExcludeOptions = this.getFilteredOptions(
            this.allMetaAudiences,
            this.SelectedMetaLALAudienceIncludeOptions
        );
    }

    private getFilteredOptions(allMetaAudiences: SelectItem[], selectedOptions: SelectItem[] = []): SelectItem[] {
        return allMetaAudiences.filter(option => !selectedOptions?.some(selected => selected.value === option.value));
    }

    audienceSelectionCondition(){
        return (this.baseCampaign.geographicTargetingJson 
                    || (!!this.SelectedMetaRTAudienceIncludeOptions && this.SelectedMetaRTAudienceIncludeOptions.length > 0)) 
            && (this.baseCampaign.geographicTargetingJson 
                    || (!!this.SelectedMetaLALAudienceIncludeOptions && this.SelectedMetaLALAudienceIncludeOptions.length > 0))
    }

    onObjectiveChange() {
        this.performanceGoalOptions = this.goalMap[this.campaignObjective] || [];
    }

    dataPixelIdcondition(){
        return this.campaignObjective == eCampaignObjectiveTypeMeta.Sales && (this.performanceGoal == ePerformanceGoalTypeMeta.Maximize_number_of_conversions || this.performanceGoal == ePerformanceGoalTypeMeta.Maximize_value_of_conversions);
    }

    validateAdAccountId() {
        const formattedAdAccountId = this.adAccountId?.trim()?.replace(/^act_/, '');
        this.isAdAccountIdValid = /^\d{10,}$/.test(formattedAdAccountId?.trim());
    }

    onlyNumbers(event: KeyboardEvent): boolean {
        const charCode = event.charCode;
        return charCode >= 48 && charCode <= 57;
    }

    prepareGoals(){
        this.goalMap = {
            1 : [
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_reach_of_ads)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_reach_of_ads,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_reach_of_ads)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_impressions)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_impressions,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_impressions)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_ad_recall_lift)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_ad_recall_lift,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_ad_recall_lift)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_ThruPlay_views)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_ThruPlay_views,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_ThruPlay_views)?.description
                // }
            ],
            2 : [
                {
                    label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_landing_page_views)?.name,
                    value: ePerformanceGoalTypeMeta.Maximize_number_of_landing_page_views,
                    description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_landing_page_views)?.description
                },
                {
                    label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_link_clicks)?.name,
                    value: ePerformanceGoalTypeMeta.Maximize_number_of_link_clicks,
                    description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_link_clicks)?.description
                },
                {
                    label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_daily_unique_reach)?.name,
                    value: ePerformanceGoalTypeMeta.Maximize_daily_unique_reach,
                    description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_daily_unique_reach)?.description
                },
                {
                    label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_conversations)?.name,
                    value: ePerformanceGoalTypeMeta.Maximize_number_of_conversations,
                    description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_conversations)?.description
                },
                {
                    label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_impressions)?.name,
                    value: ePerformanceGoalTypeMeta.Maximize_number_of_impressions,
                    description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_impressions)?.description
                },
                {
                    label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_Instagram_profile_visits)?.name,
                    value: ePerformanceGoalTypeMeta.Maximize_number_of_Instagram_profile_visits,
                    description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_Instagram_profile_visits)?.description
                },
                {
                    label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_calls)?.name,
                    value: ePerformanceGoalTypeMeta.Maximize_number_of_calls,
                    description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_calls)?.description
                }
            ],
            3 : [
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_conversations)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_conversations,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_conversations)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_link_clicks)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_link_clicks,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_link_clicks)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_impressions)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_impressions,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_impressions)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_ThruPlay_views)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_ThruPlay_views,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_ThruPlay_views)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_engagement_with_a_post)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_engagement_with_a_post,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_engagement_with_a_post)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_daily_unique_reach)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_daily_unique_reach,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_daily_unique_reach)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_event_responses)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_event_responses,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_event_responses)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_conversations)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_conversations,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_conversations)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_landing_page_views)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_landing_page_views,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_landing_page_views)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_app_events)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_app_events,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_app_events)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_reminders_set)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_reminders_set,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_reminders_set)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_calls)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_calls,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_calls)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_page_likes)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_page_likes,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_page_likes)?.description
                // }
            ],
            4 : [
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_conversations)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_conversations,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_conversations)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_landing_page_views)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_landing_page_views,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_landing_page_views)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_link_clicks)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_link_clicks,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_link_clicks)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_daily_unique_reach)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_daily_unique_reach,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_daily_unique_reach)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_impressions)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_impressions,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_impressions)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_leads)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_leads,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_leads)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_conversion_leads)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_conversion_leads,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_conversion_leads)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_leads_through_messaging)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_leads_through_messaging,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_leads_through_messaging)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_calls)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_calls,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_calls)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_app_events)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_app_events,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_app_events)?.description
                // }
            ],
            5 : [
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_app_events)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_app_events,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_app_events)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_app_installs)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_app_installs,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_app_installs)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_value_of_conversions)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_value_of_conversions,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_value_of_conversions)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_link_clicks)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_link_clicks,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_link_clicks)?.description
                // }
            ],
            6 : [
                {
                    label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_conversations)?.name,
                    value: ePerformanceGoalTypeMeta.Maximize_number_of_conversations,
                    description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_conversations)?.description
                },
                {
                    label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_value_of_conversions)?.name,
                    value: ePerformanceGoalTypeMeta.Maximize_value_of_conversions,
                    description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_value_of_conversions)?.description
                },
                {
                    label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_landing_page_views)?.name,
                    value: ePerformanceGoalTypeMeta.Maximize_number_of_landing_page_views,
                    description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_landing_page_views)?.description
                },
                {
                    label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_link_clicks)?.name,
                    value: ePerformanceGoalTypeMeta.Maximize_number_of_link_clicks,
                    description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_link_clicks)?.description
                },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_purchases_through_messaging)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_purchases_through_messaging,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_purchases_through_messaging)?.description
                // },
                {
                    label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_daily_unique_reach)?.name,
                    value: ePerformanceGoalTypeMeta.Maximize_daily_unique_reach,
                    description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_daily_unique_reach)?.description
                },
                {
                    label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_impressions)?.name,
                    value: ePerformanceGoalTypeMeta.Maximize_number_of_impressions,
                    description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_impressions)?.description
                },
                {
                    label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_conversions)?.name,
                    value: ePerformanceGoalTypeMeta.Maximize_number_of_conversions,
                    description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_conversions)?.description
                },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_calls)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_calls,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_calls)?.description
                // },
                // {
                //     label: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_app_events)?.name,
                //     value: ePerformanceGoalTypeMeta.Maximize_number_of_app_events,
                //     description: ePerformanceGoalTypeMetaName.get(ePerformanceGoalTypeMeta.Maximize_number_of_app_events)?.description
                // }
            ]
        }
    }
}